export default [
    {
        path: '',
        name: 'pageCultureRouter',
        component: () => import('./page-culture')
    }
]